<template>
	<vx-card>
		<vs-popup
			:active.sync="showPassPopup"
			title="Modification du mot de passe d'un collaborateur"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/3 w-full">
					<vs-input
						class="w-full"
						placeholder="Mot de passe"
						label="Mot de passe"
						v-model="newPass"
					/>
				</div>
				<div class="vx-col sm:w-1/3 w-full">
					<vs-button class="mt-2" @click="savePassword">Enregistrer</vs-button>
				</div>
			</div>
		</vs-popup>
		<div class="vx-col">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<h3>Modifier un collaborateur Rankwell</h3>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-button
						class="float-right"
						radius
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-x"
						@click="returnPrevRoute"
					></vs-button>
				</div>
			</div>
			<div class="vx-row mt-4">
				<div class="vx-col sm:w-1/2 w-full mb-2 flex">
					<!-- USER -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="person" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							:style="styleValidator('firstname')"
							class="w-full"
							placeholder="Prénom"
							v-model="collaborator.firstname"
							@change="validateOne(collaborator.firstname, 'firstname')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="
							validators['firstname'] && validators['firstname'].errText !== ''
						"
						:text="errText('firstname')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /USER -->
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<!-- USER -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="person" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							:style="styleValidator('lastname')"
							class="w-full"
							placeholder="Nom"
							v-model="collaborator.lastname"
							@change="validateOne(collaborator.lastname, 'lastname')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="
							validators['lastname'] && validators['lastname'].errText !== ''
						"
						:text="errText('lastname')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /USER -->
				</div>
			</div>
			<div class="vx-row mt-5">
				<div class="vx-col sm:w-1/2 w-full mb-2 flex">
					<!-- EMAIL -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="alternate_email" size="small"></vs-icon
								></span>
							</div>
						</template>

						<vs-input
							:style="styleValidator('email')"
							v-model="collaborator.email"
							placeholder="Email"
							@change="validateOne(collaborator.email, 'email')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="validators['email'] && validators['email'].errText !== ''"
						:text="errText('email')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /EMAIL -->
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2 flex">
					<!-- PHONE -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="local_phone" size="small"></vs-icon
								></span>
							</div>
						</template>

						<vs-input
							:style="styleValidator('phone')"
							v-model="collaborator.phone"
							placeholder="Téléphone"
							@change="validateOne(collaborator.phone, 'phone')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="validators['phone'] && validators['phone'].errText !== ''"
						:text="errText('phone')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /PHONE -->
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-select
						v-if="$acl.check('sadmin')"
						autocomplete
						:style="styleValidator('type')"
						v-model="collaborator.type"
						class="w-3/4 select-large mt-4"
						placeholder="Type de contact"
						@change="validateOne(collaborator.type, 'type')"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in typeOptions"
							class="w-full"
						/>
					</vs-select>
					<vs-select
						v-else
						autocomplete
						:style="styleValidator('type')"
						v-model="collaborator.type"
						class="w-3/4 select-large mt-4"
						placeholder="Type de contact"
						@change="validateOne(collaborator.type, 'type')"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in adminTypeOptions"
							class="w-full"
						/>
					</vs-select>
					<vx-tooltip
						v-if="validators['type'] && validators['type'].errText !== ''"
						:text="errText('type')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-select
						autocomplete
						v-model="collaborator.status"
						class="w-3/4 select-large mt-4"
						placeholder="Statut"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in statusOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<!-- IMAGE -->
			<file-pond
				ref="imageUp"
				@addfile="addImageToPost()"
				accepted-file-types="image/jpeg, image/png"
				label-idle="Déposez l'image de profil ici ou cliquez le champ pour l'ajouter (.png ou .jpg seulement)..."
			/>
			<!-- /IMAGE -->
			<div class="vx-row">
				<!-- <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-textarea
            v-model="collaborator.commentary"
            label="Commentaire"
            class="mb-0 md:mt-10 mt-6"
            rows="3"
          />
        </div> -->
				<div class="vx-col">
					<vs-button @click="modifyPassword"
						>Modification du mot de passe</vs-button
					>
				</div>
			</div>
			<div class="vx-row mt-3 right_element">
				<div class="vx-col">
					<!-- <vs-button
            color="warning"
            type="border"
            class="mb-2 mr-3"
            @click="resetForm(collaborator)"
            >Réinitialiser</vs-button
          > -->
					<vs-button class="mb-2" @click="validateAll()">Enregistrer</vs-button>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import { Collaborator } from "@/entities/Collaborator";
import utilsMixin from "@/mixins/utilsMixin";
import Validator from "@/entities/Validator";

// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

// Import styles
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Create FilePond component
const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview
);

export default {
	name: "UpdateCollaboratorForm",
	components: {
		FilePond,
		VxTooltip,
	},
	props: {
		chartParams: Object,
		isPercent: Boolean,
	},
	mixins: [utilsMixin],
	created() {
		this.$http
			.get(this.apiUrl + "users/get/" + this.$route.params.collaboratorId)
			.then((collaborator) => {
				this.collaborator = new Collaborator(collaborator.data[0]);
				this.collaboratorOld = new Collaborator(collaborator.data[0]);
			})
			.catch((err) => {
				//console.log(err);
			});
	},
	data() {
		return {
			// USER OBJECT
			collaborator: Collaborator.getFormFields(),
			collaboratorOld: Collaborator.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,
			newPass: "",
			// FORM SELECT OPTIONS
			statusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "Inactif", value: 0 },
			],
			/**
			 * Refer to backend server to understand more about type and its possible value
			 */
			typeOptions: [
				{ text: "Collaborateur externe", value: 7 },
				{ text: "Comptabilité", value: 8 },
				{ text: "Consultant", value: 3 },
				{ text: "Sales", value: 4 },
				{ text: "Administrateur", value: 6 },
				{ text: "Super Administrateur", value: 9 },
			],
			adminTypeOptions: [
				{ text: "Collaborateur externe", value: 7 },
				{ text: "Comptabilité", value: 8 },
				{ text: "Consultant", value: 3 },
				{ text: "Sales", value: 4 },
			],
			showPassPopup: false,
			validators: {},
			check: true,
		};
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	methods: {
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		addImageToPost() {
			let image = this.$refs.imageUp.getFile();
			let formData = new FormData();
			formData.append("image", image.file);
			this.imagetoUpdate = formData;
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = name + "Constraint";
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			this.validators[name].errText == "" &&
			this.validators[name].valid == false
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false ? (this.check = false) : "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].valid == false) {
				if (name == "type") {
					return "border: 1px solid red !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				}
			} else if (this.validators[name] && this.validators[name].valid == true) {
				if (name == "type") {
					return "border: 1px solid green !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				}
			} else {
			}
		},
		validateAll() {
			this.check = true;
			let fields = ["firstname", "lastname", "email", "phone", "type"];
			for (let i = 0; i < fields.length; i++) {
				let name = fields[i] + "Constraint";
				let value = this.collaborator[fields[i]];
				value == 0 ? (value = "0") : "";
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].errText == "" &&
				this.validators[fields[i]].valid == false
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				this.validators[fields[i]].valid == false ? (this.check = false) : "";
				this.$forceUpdate();
			}
			this.check == true ? this.formSubmitted() : "";
		},
		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Rankwell.vue
		 */
		formSubmitted() {
			if (!this.collaborator.compare(this.collaboratorOld)) {
				this.$http
					.post(this.apiUrl + "users/update", {
						user: {
							id: this.collaborator.id,
							email: this.collaborator.email,
							password: this.collaborator.password,
							firstname: this.collaborator.firstname,
							lastname: this.collaborator.lastname,
							role: 1,
							phone: this.collaborator.phone,
							image_url: this.collaborator.image_url,
							commentary: this.collaborator.commentary,
							status: this.collaborator.status,
							type: this.collaborator.type,
							civility: this.collaborator.civility,
							hasAccess: this.collaborator.hasAccess,
						},
					})
					.then((res) => {
						//console.log(res);
						if (this.imagetoUpdate) {
							this.$http
								.post(
									this.apiUrl + "users/update/image/" + res.data.id,
									this.imagetoUpdate,
									{
										headers: {
											accept: "application/json",
											"Accept-Language": "en-US,en;q=0.8",
											"Content-Type": `multipart/form-data; boundary=${this.imagetoUpdate._boundary}`,
										},
									}
								)
								.then(() => {
									this.getAllCollaboratorsAvatar();
									this.$vs.notify({
										title: "Succès",
										text: "Collaborateur modifié avec succès.",
									});
									// Send the user to the previous route
									this.$router.go(-1);
								})
								.catch((error) => {
									//console.log(error);
									this.$vs.notify({
										title: "Echec",
										text: "Le collaborateur n'a pas été modifié.",
									});
								});
						} else {
							// Send a success notification to the user
							this.$vs.notify({
								title: "Succès",
								text: "Collaborateur modifié avec succès.",
							});
							// Send the user to the previous route
							this.$router.go(-1);
						}
					});
			} else if (this.imagetoUpdate) {
				this.$http
					.post(
						this.apiUrl + "users/update/image/" + this.collaborator.id,
						this.imagetoUpdate,
						{
							headers: {
								accept: "application/json",
								"Accept-Language": "en-US,en;q=0.8",
								"Content-Type": `multipart/form-data; boundary=${this.imagetoUpdate._boundary}`,
							},
						}
					)
					.then(() => {
						this.getAllCollaboratorsAvatar();
						this.$vs.notify({
							title: "Succès",
							text: "Collaborateur modifié avec succès.",
						});
						// Send the user to the previous route
						this.$router.go(-1);
					})
					.catch((error) => {
						//console.log(error);
						this.$vs.notify({
							title: "Echec",
							text: "Le collaborateur n'a pas été modifié.",
						});
					});
			} else {
				this.$vs.notify({
					title: "Aucune modification",
					text: "Le collaborateur n'a pas été modifié.",
				});
			}
		},

		modifyPassword() {
			this.showPassPopup = true;
		},

		savePassword() {
			if (this.collaborator.id && this.newPass) {
				this.$http
					.post(this.apiUrl + "users/update/spass", {
						id: this.collaborator.id,
						newPassword: this.newPass,
					})
					.then(() => {
						this.$vs.notify({
							title: "Succès",
							text: "Le mot de passe a été mis à jour.",
						});
						this.showPassPopup = false;
					})
					.catch((err) => {
						this.$vs.notify({
							title: "Erreur",
							text: "Le mot de passe n'a pas été mis à jour.",
							color: "danger",
						});
						//console.log(err);
					});
			} else {
				this.$vs.notify({
					title: "Erreur",
					text: "Remplissez tous les champs pour modifier le mot de passe",
					color: "danger",
				});
			}
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.right_element {
	justify-content: flex-end;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}
</style>
